// extracted by mini-css-extract-plugin
export default {"contenedor":"CampoBuscarEstadio_contenedor__jcPUl","boton":"CampoBuscarEstadio_boton__r7nK-"};